// Centralized memorial content (Sprint 6).
// ALL copy here is editable placeholder content pending project-owner approval.
// No specific biographical facts, dates, quotations, or family details are
// included — real approved writing and photos replace this file later.

// Flip to false to see the unpublished memorial state.
export const MEMORIAL_PUBLISHED = true;

// Shows the informational "Share a Memory" section (no form, no submissions).
export const SHARE_MEMORY_ENABLED = true;

export const MEMORIAL = {
  hero: {
    title: "In Memory of Brandon Dalleo",
    subtitle: "Friendship, tradition, and a legacy that continues every year.",
    photoAlt: "Photo of Brandon Dalleo — to be provided by the family",
  },
  story: [
    "Brandon brought people together through friendship, humor, and the moments shared with the people closest to him.",
    "The Dalleo Open was created to keep that connection alive. Each year, friends gather to compete, laugh, remember, and continue a tradition built around the relationships Brandon helped create.",
  ],
  values: [
    {
      id: "remember",
      title: "Remember",
      sentence: "Honor Brandon and keep his memory present.",
    },
    {
      id: "celebrate",
      title: "Celebrate",
      sentence: "Share stories, laughter, and traditions.",
    },
    {
      id: "compete",
      title: "Compete",
      sentence: "Enjoy the tournament and friendly rivalry.",
    },
    {
      id: "stay-connected",
      title: "Stay Connected",
      sentence: "Bring friends together year after year.",
    },
  ],
  milestones: [
    {
      id: "m1",
      title: "The First Dalleo Open",
      description: "Friends gather to play in Brandon's honor, and a tradition is born.",
    },
    {
      id: "m2",
      title: "A Growing Tradition",
      description: "What begins as a single round becomes a weekend everyone looks forward to.",
    },
    {
      id: "m3",
      title: "Draft Night Joins the Weekend",
      description: "The Friday draft adds a new layer of fun, rivalry, and laughter.",
    },
    {
      id: "m4",
      title: "The Tournament Continues Today",
      description: "Each year, old friends and new faces keep the tradition alive.",
    },
  ],
  photos: {
    featured: {
      id: "mp-featured",
      alt: "Featured memorial photo placeholder — to be provided",
      caption: "A favorite memory",
      aspect: "landscape",
    },
    supporting: [
      {
        id: "mp-1",
        alt: "Memorial photo placeholder — to be provided",
        caption: "Friends on the course",
        aspect: "square",
      },
      {
        id: "mp-2",
        alt: "Memorial photo placeholder — to be provided",
        caption: "Moments that last",
        aspect: "square",
      },
    ],
  },
  shareMemory: {
    title: "Share a Memory",
    body: "A future update will make it possible for friends and participants to contribute memories and photos.",
  },
  closing: {
    message:
      "The Dalleo Open is more than a tournament. It is a yearly reminder of friendship, the memories people carry, and the importance of continuing to show up for one another.",
  },
  homeMessage:
    "The Dalleo Open began as a way for friends to honor Brandon Dalleo — his love of the game and the way he brought people together. Today it remains a weekend about friendship, remembrance, and continuing to show up for one another.",
};
